// extracted by mini-css-extract-plugin
export default {"head":"Dz1bJ1q4zbdHa9PNw6Z9","info":"z7tIVfvGtTSiopavHBPZ","body":"DQJyBeDIZuNOXjpONywf","title":"LoEoUNrY49IeRJk1CCDp"};